import { render, staticRenderFns } from "./PageResetPassword.vue?vue&type=template&id=05dc2260"
import script from "./PageResetPassword.vue?vue&type=script&lang=js"
export * from "./PageResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05dc2260')) {
      api.createRecord('05dc2260', component.options)
    } else {
      api.reload('05dc2260', component.options)
    }
    module.hot.accept("./PageResetPassword.vue?vue&type=template&id=05dc2260", function () {
      api.rerender('05dc2260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PageResetPassword.vue"
export default component.exports